import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { usuarioLider } from '../../Redux/legajo';
import TokenContext from '../../context/TokenContext';
import { UserAuth } from '../../context/AuthContext';

const useLider = () => {
    const dispatch = useDispatch();
    const token = useContext(TokenContext);
    const { empleado } = UserAuth();
    const liderSelector = useSelector((store) => store.legajo.usuarioLider);
    const [lider, setLider] = useState(null);

    useEffect(() => {
        if (token && empleado) {
            dispatch(usuarioLider(token, empleado.usuarioPortalRh));
        }
    }, [token, empleado]);

    useEffect(() => {
        if (liderSelector.length > 0) {
            setLider(true)
        } else {
            setLider(false)
        }
    }, [liderSelector])

    return { lider }
}

export default useLider